export enum Status {
    unknown = 'unknown',
    met = 'met',
    open = 'open',
    unmet = 'unmet'
}